import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { Observable } from 'rxjs';
import { Queue } from '../../models/queue/queue.model';
import { environment } from 'environments/environment';

const baseUrl = `${environment.API_URL}/user-call-queue`;

@Injectable({
  providedIn: 'root'
})
export class QueueService {

  constructor(private http: ApiHttpClient) {}

  getUserQueue(): Observable<Queue[]> {
    return this.http.get<Queue[]>(baseUrl);
  }

  addToQueue(borrowerId: number): Observable<Queue[]> {
    return this.http.post<Queue[]>(`${baseUrl}?borrowerId=${borrowerId}`, null);
  }

  updateQueue(queue: Queue[]): Observable<Queue[]> {
    return this.http.put<Queue[]>(baseUrl, queue);
  }

  deleteQueue(borrowerId: number | null, all: boolean): Observable<Queue[]> {
    const endpoint = all ? `${baseUrl}?all=true` : `${baseUrl}?borrowerId=${borrowerId}`;
    return this.http.delete<Queue[]>(endpoint);
  }
}
